import type { Media } from './media';
export enum MemberStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING_DELETION = 'pending_deletion',
  IDLE = 'idle',
  CANCELLED = 'cancelled',
  PAUSED = 'paused',
  EXPIRED = 'expired',
  PAYMENT_FAILED = 'payment_failed',
  PAST_DUE = 'past_due',
  SUSPENDED = 'suspended',
  PRESALE = 'presale',
}

export enum SubscriptionStatus {
  SCHEDULED = 'Scheduled',
  ACTIVE = 'Active',
  CANCELLED = 'Cancelled',
  PAYMENT_FAILED = 'Payment Failed',
  PAUSED = 'Paused',
}

export enum GenderEnum {
  MALE = 'Male',
  FEMALE = 'Female',
  UNSPECIFIED = 'Unspecified',
}

export interface MemberProfile {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  mobile: string;
  gender?: string;
  dob?: string;
  address?: MemberAddress;
  avatar?: string;
  avatarMedia?: Media;
  status?: MemberStatus;
  subscriptionStatus?: SubscriptionStatus;
  subscriptionStatusChangedAt?: string;
  locationId?: string;
  crmId?: string;
  franchiseId?: string;
  lastLogin?: string;
  roleId?: string;
  createdAt?: string;
  dropInBookingBlocked?: boolean;
}

export interface MemberAddress {
  line1?: string;
  city?: string;
  state?: string;
  country?: string;
  postalCode?: string;
}

export interface UpdateMemberProfileDto {
  firstName?: string;
  lastName?: string;
  gender?: string;
  dob?: string;
  address?: MemberAddress;
}

export interface UploadAvatarResponse {
  avatarUrl: string;
}
